import { c as _c } from "react-compiler-runtime";
import { useEffect, useMemo } from 'react';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import { Metrics } from 'framework-listing-lib/internal/metrics';
import useSkipCrm from 'framework-listing-lib/internal/hooks/useSkipCrm';
import { PropertyGroups } from 'hs-resources/resources/PropertyGroups';
import { ObjectTypeDefinitions } from 'hs-resources/resources/ObjectTypeDefinition';
import { useResource } from 'pulse/react';
export default function useFetchListingLibData(t0) {
  "use memo";

  const $ = _c(37);
  const {
    showHighlySensitiveProperties
  } = t0;
  const objectTypeId = useObjectTypeId();
  const skipCrm = useSkipCrm();
  let t1;
  if ($[0] !== objectTypeId || $[1] !== showHighlySensitiveProperties) {
    t1 = {
      objectTypeId,
      showHighlySensitiveProperties
    };
    $[0] = objectTypeId;
    $[1] = showHighlySensitiveProperties;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== skipCrm || $[4] !== t1) {
    t2 = {
      params: t1,
      skip: skipCrm
    };
    $[3] = skipCrm;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data: propertyGroupsData,
    loading: propertyGroupsloading,
    error: propertyGroupsError
  } = useResource(PropertyGroups, t2);
  let t3;
  if ($[6] !== skipCrm) {
    t3 = {
      skip: skipCrm
    };
    $[6] = skipCrm;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data: objectTypesData,
    loading: objectTypesloading,
    error: objectTypesError
  } = useResource(ObjectTypeDefinitions, t3);
  let t4;
  let t5;
  if ($[8] !== objectTypeId || $[9] !== propertyGroupsData) {
    t4 = () => {
      if (propertyGroupsData) {
        Metrics.counter("fetch-properties-success", {
          object_type_id: objectTypeId
        }).increment();
      }
    };
    t5 = [propertyGroupsData, objectTypeId];
    $[8] = objectTypeId;
    $[9] = propertyGroupsData;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[12] !== objectTypeId || $[13] !== propertyGroupsError) {
    t6 = () => {
      if (propertyGroupsError) {
        Metrics.counter("fetch-properties-failure", {
          object_type_id: objectTypeId
        }).increment();
      }
    };
    t7 = [propertyGroupsError, objectTypeId];
    $[12] = objectTypeId;
    $[13] = propertyGroupsError;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[16] !== objectTypeId || $[17] !== objectTypesData) {
    t8 = () => {
      if (objectTypesData) {
        Metrics.counter("fetch-object-types-success", {
          object_type_id: objectTypeId
        }).increment();
      }
    };
    t9 = [objectTypesData, objectTypeId];
    $[16] = objectTypeId;
    $[17] = objectTypesData;
    $[18] = t8;
    $[19] = t9;
  } else {
    t8 = $[18];
    t9 = $[19];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[20] !== objectTypeId || $[21] !== objectTypesError) {
    t10 = () => {
      if (objectTypesError) {
        Metrics.counter("fetch-object-types-failure", {
          object_type_id: objectTypeId
        }).increment();
      }
    };
    t11 = [objectTypesError, objectTypeId];
    $[20] = objectTypeId;
    $[21] = objectTypesError;
    $[22] = t10;
    $[23] = t11;
  } else {
    t10 = $[22];
    t11 = $[23];
  }
  useEffect(t10, t11);
  let t12;
  bb0: {
    if (!propertyGroupsData || !Array.isArray(propertyGroupsData)) {
      let t13;
      if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = [];
        $[24] = t13;
      } else {
        t13 = $[24];
      }
      t12 = t13;
      break bb0;
    }
    let t13;
    if ($[25] !== propertyGroupsData) {
      t13 = propertyGroupsData.map(_temp2);
      $[25] = propertyGroupsData;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    t12 = t13;
  }
  const propertyGroups = t12;
  const t13 = propertyGroupsError || objectTypesError;
  const t14 = propertyGroupsloading || objectTypesloading;
  let t15;
  if ($[27] !== propertyGroups) {
    t15 = propertyGroups.map(_temp3).flat().filter(_temp4);
    $[27] = propertyGroups;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== objectTypesData) {
    t16 = objectTypesData && Array.isArray(objectTypesData) ? objectTypesData : [];
    $[29] = objectTypesData;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== propertyGroups || $[32] !== t13 || $[33] !== t14 || $[34] !== t15 || $[35] !== t16) {
    t17 = {
      error: t13,
      loading: t14,
      properties: t15,
      propertyGroups,
      typeDefinitions: t16
    };
    $[31] = propertyGroups;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
}
function _temp4(property) {
  return property !== undefined;
}
function _temp3(propertyGroup_0) {
  return propertyGroup_0.properties;
}
function _temp2(propertyGroup) {
  return Object.assign({}, propertyGroup, {
    label: propertyGroup.displayName,
    properties: Array.isArray(propertyGroup.propertyDefinitions) ? propertyGroup.propertyDefinitions.map(_temp) : []
  });
}
function _temp(definition) {
  return Object.assign({}, definition.property, {
    fieldType: definition.property.fieldType,
    sensitiveDataCategories: definition.property.sensitiveDataCategories,
    type: definition.property.type
  });
}